import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import { CartChangeFiltersContext } from '../../../../context/CartChangeFiltersContext'
import ChartColumn from '../../../../components/charts/ChartColumn'
import ChartColumnSkeleton from '../../../../components/skeletons/ChartColumnSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { formatNumber } from '../../../../utils/Helpers'
// import { GET_CART_CHANGE_OPENED_STATES } from '../../../../queries/cartChange'

const GET_CART_CHANGE_OPENED_STATES = gql`
  query GetMostOpened($filters: EventCartChangeFilter) {
    eventCartChangeAggs(
      filters: $filters,
      index: "eventos-fapp-cart-change-opened*",
      size: 0,
      aggs: {
        states: {
          terms: {
            field: "geoip.region_name.keyword",
            size: 5
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string
  doc_count: number
}
const CartChangeOpenedStates = (): JSX.Element => {
  const { filters } = useContext(CartChangeFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_CART_CHANGE_OPENED_STATES, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data) return <ChartColumnSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.eventCartChangeAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.eventCartChangeAggs.aggregations.states
  const categories: Array<string> = []
  const seriesData: Array<number> = []
  buckets.map((bucket: Bucket) => {
    categories.push(bucket.key)
    return seriesData.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'state-more-opened-events'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      offsetY: -20,
      formatter: (val: number) => {
        return formatNumber(val, 0, true)
      },
      style: {
        colors: ['#304758']
      }
    },
    yaxis: {
      labels: {
        formatter: (value: number) => {
          return formatNumber(value, 0, true)
        }
      }
    }
  }
  const series = [{
    name: 'Aberturas',
    data: seriesData
  }]

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography
      paragraph
      style={{ paddingLeft: '20px', paddingTop: '20px' }}
    >
      TOP 5 estados com mais eventos de abertura
    </Typography>
    <ChartColumn options={options} series={series} theme={ChartColumnThemes.orange} height={280} />
  </Paper>
}

export default CartChangeOpenedStates
